module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#photo",
      toString: function () {
        return this.url;
      }
    }